auth token {{ accessToken }}
<div style="margin:40px 60px;">
  <dl>
    <dt>user id:</dt>
    <dd id="userId">{{ user?.userId }}</dd>
    <dt>user email:</dt>
    <dd id="userEmail">{{ user?.email }}</dd>
    <dt>first name:</dt>
    <dd id="userFirstName">{{ user?.firstName }}</dd>
    <dt>last name:</dt>
    <dd id="userLastName">{{ user?.lastName }}</dd>
  </dl>
</div>
<div style="text-align: center">
  <button
    aur-button
    icon="arrow_forward"
    id="btnLogOut"
    importance="primary"
    (click)="logout($event)"
  >
    Logout
  </button>
</div>
